<script>
import _ from 'underscore';
import { Multiselect, Panel, SelectField } from 'vue-bootstrap';
import Draggable from '../../exports/components/DraggableColumns';
import Judge from './Judge';
import RemovableList from './RemovableList';
import SearchPanel from './SearchPanel';

export default {
  components: {
    Draggable,
    Judge,
    Multiselect,
    Panel,
    RemovableList,
    SearchPanel,
    SelectField
  },
  props: {
    url: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: value => ['roles', 'invited'].indexOf(value) !== -1
    },
    initSelectedJudges: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isLoaded: false,
      searchWasRun: false,
      selectorType: null,
      judgeFilters: {},
      judges: [],
      selectedJudges: []
    };
  },
  computed: {
    selectedJudgesIds() {
      return _.pluck(this.selectedJudges, 'id');
    },
    judgesForSearch() {
      return JSON.parse(JSON.stringify(this.judges));
    },
    selectedJudgesForSearch() {
      return JSON.parse(JSON.stringify(this.selectedJudgesIds));
    }
  },
  created() {
    this.selectorType = this.type;
    this.selectedJudges = this.initSelectedJudges;

    // Fix: Prevent selected judges from getting emptied just after mounted
    this.$nextTick(() => {
      this.isLoaded = true;
    });
  },
  methods: {
    changeSelectedJudges(selectedJudgeIds) {
      if (!this.isLoaded) {
        return;
      }

      let newSelectedJudges = [];
      let oldSelectedJudges = JSON.parse(JSON.stringify(this.selectedJudges));
      for (let judge of oldSelectedJudges) {
        if (!this.isJudgeInSearchResult(judge.id)) {
          newSelectedJudges.push(judge);
        }
      }

      for (let judgeId of selectedJudgeIds) {
        newSelectedJudges.push(this.getJudgeById(judgeId));
      }

      this.$set(
        this,
        'selectedJudges',
        newSelectedJudges.sort((a, b) => (a.name + '').localeCompare(b.name))
      );
    },
    judgeUnselected(judgeId) {
      this.selectedJudges = this.selectedJudges.filter(
        judge => judge.id !== judgeId
      );
    },
    isJudgeInSearchResult(judgeId) {
      return this.judges.filter(judge => judge.id === judgeId).length > 0;
    },
    isJudgeSelected(judgeId) {
      return this.selectedJudges.contains(judgeId);
    },
    judgeSearchResults(data) {
      this.isLoaded = false;

      this.judges = data;

      // Don't lose selected judges upon new search results
      this.$nextTick(() => {
        this.isLoaded = true;
        this.searchWasRun = true;
      });
    },
    getJudgeById(judgeId) {
      return this.judges.find(judge => judge.id === judgeId);
    },
    resetJudges() {
      this.judges = [];
      this.judgeFilters = {};
      this.searchWasRun = false;
    },
    selectJudges(judges) {
      this.selectedJudges = judges;
    },
    selectJudgeFilter(name, value) {
      this.$set(this.judgeFilters, name, value);
    }
  }
};
</script>

<style>
.judge-selector .multiselect-option span.af-icons {
  vertical-align: middle;
  margin-left: 2px;
  padding-bottom: 3px;
}
</style>
